import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { COMPANY } from '../lib/company';

const WhatsAppButton = () => {
  const [open, setOpen] = useState(false);
  const message = encodeURIComponent('Bună ziua! Aș dori mai multe informații despre produsele AXA.');
  const link = `https://wa.me/${COMPANY.whatsapp}?text=${message}`;

  return (
    <>
      {/* Popup card */}
      <div
        className={`fixed bottom-24 right-5 z-[90] w-80 max-w-[calc(100vw-2.5rem)] bg-white rounded-2xl shadow-2xl border border-neutral-200 overflow-hidden transition-all duration-300 origin-bottom-right ${
          open ? 'opacity-100 scale-100' : 'opacity-0 scale-95 pointer-events-none'
        }`}
      >
        <div className="bg-[#075E54] px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
              <MessageCircle className="w-5 h-5 text-white" />
            </div>
            <div>
              <div className="text-white font-semibold text-sm">AXA Suport</div>
              <div className="text-white/80 text-xs flex items-center gap-1">
                <span className="w-1.5 h-1.5 rounded-full bg-green-400" />
                Online acum
              </div>
            </div>
          </div>
          <button
            onClick={() => setOpen(false)}
            className="text-white/80 hover:text-white"
            aria-label="Închide"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="p-4 bg-[#ECE5DD]">
          <div className="bg-white rounded-lg rounded-tl-none p-3 shadow-sm max-w-[90%]">
            <p className="text-sm text-neutral-800">
              Bună ziua! 👋 Cu ce vă putem ajuta astăzi?
            </p>
            <p className="text-xs text-neutral-500 mt-1">
              Răspundem de obicei în câteva minute.
            </p>
          </div>
        </div>
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe57] text-white font-medium py-3 text-sm transition-colors"
        >
          <MessageCircle className="w-4 h-4" />
          Începe conversația
        </a>
      </div>

      {/* Floating button */}
      <button
        onClick={() => setOpen(!open)}
        className="fixed bottom-5 right-5 z-[85] w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white shadow-2xl shadow-green-500/40 flex items-center justify-center transition-all hover:scale-110"
        aria-label="WhatsApp"
      >
        <svg viewBox="0 0 24 24" className="w-7 h-7 fill-current" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
        {!open && (
          <span className="absolute -top-1 -right-1 flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500" />
          </span>
        )}
      </button>
    </>
  );
};

export default WhatsAppButton;
